import { Button, Flex, Form, FormInstance, Input } from "antd";
import { useEffect } from "react";
import AddIcon from "../../../../../assets/icons/AddIcon";
import PencilLine from "../../../../../assets/icons/PencilLine";
import CustomDrawer from "../../../../../components/ui/CustomDrawer";
import FileUpload from "../../../../../components/ui/FileUpload";
import useModal from "../../../../../hooks/useModal";

export type ModalType = "ADD-FILE" | "UPDATE-FILE";
export type ModalData = { index: number };

const Documents = ({ form }: { form: FormInstance<any> }) => {
  const [fileForm] = Form.useForm();
  const { open, handleOpen, handleClose } = useModal<ModalData, ModalType>();

  const businessDocuments = Form.useWatch("documents", form);
  const selectedDoc = businessDocuments?.[open.data?.index as number];

  // ------ Function for add/update business documents ------
  const handleDocSave = (values: Record<string, unknown>) => {
    const index = open?.data?.index;
    const currentList = businessDocuments ?? [];
    let updatedList = [...currentList];

    if (typeof index === "number") {
      // Update existing bank info
      updatedList = currentList.map((item: any, i: number) =>
        i === index ? { ...item, ...values } : item,
      );
    } else {
      // Add new bank info
      updatedList = [...currentList, values];
    }

    form.setFieldsValue({ documents: updatedList });
    handleClose();
  };
  
  useEffect(() => {
    fileForm.setFieldsValue(selectedDoc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, fileForm]);
  return (
    <div className="space-y-6 p-5 rounded-xl border border-theme-indigo-50 mb-5">
      <h5 className="text-lg text-theme-gray-2 font-semibold">
        Vendor Contacts
      </h5>

      <Form
        className="custom-form"
        layout="vertical"
        // requiredMark="optional"
        size="large"
        form={form}
      >
        <Form.List
          name={"documents"}
          initialValue={[
            { document_name: "Trade License (TL)", document_url: undefined },
            {
              document_name: "TAX Identification Number (TIN)",
              document_url: undefined,
            },
            {
              document_name: "Business Identification Number (BIN)",
              document_url: undefined,
            },
          ]}
        >
          {(fields, { add, remove }) => {
            const filteredDocs = businessDocuments?.filter(
              (item: any) => item !== undefined,
            );
            return (
              <div>
                <div className="grid grid-cols-3 gap-x-4">
                  {filteredDocs?.length
                    ? fields.map(({ key, name, ...restField }, index) => {
                        if (businessDocuments?.[name] === undefined) {
                          return null;
                        }
                        const labelValue = form.getFieldValue([
                          "documents",
                          index,
                          "document_name",
                        ]);
                        return (
                          <div>
                            <Form.Item
                              {...restField}
                              name={[name, "document_url"]}
                              rootClassName="full-label"
                              label={
                                <Flex
                                  justify="space-between"
                                  className="!w-full"
                                >
                                  <span>{labelValue}</span>
                                  <button
                                    onClick={() => {
                                      handleOpen({
                                        type: "UPDATE-FILE",
                                        data: { index: name || 0 },
                                      });
                                    }}
                                    type="button"
                                    className="cursor-pointer"
                                  >
                                    <PencilLine />
                                  </button>
                                </Flex>
                              }
                            >
                              <FileUpload
                                form={form}
                                accept=".png,.jpeg,.svg,.pdf"
                                name={
                                  [name, "document_url"] as unknown as string
                                }
                                value={businessDocuments?.[index]?.document_url}
                                description="PDF, JPG, PNG (Max 5MB)"
                              />
                            </Form.Item>
                          </div>
                        );
                      })
                    : null}
                </div>
                <Button
                  size="small"
                  onClick={() => {
                    add();
                    handleOpen({
                      type: "ADD-FILE",
                      data: { index: fields?.length || 0 },
                    });
                  }}
                  className="button-primary-light"
                >
                  <AddIcon /> More
                </Button>

                <CustomDrawer
                  title={!selectedDoc ? "Add More" : "Edit Field"}
                  open={open.open}
                  onClose={() => {
                    open.type === "ADD-FILE" &&
                      remove(open.data?.index as number);
                    fileForm.resetFields();
                    handleClose();
                  }}
                >
                  <Form
                    className="custom-form"
                    layout="vertical"
                    // requiredMark="optional"
                    size="large"
                    form={fileForm}
                    onFinish={(values) => {
                      handleDocSave(values);
                      fileForm.resetFields();
                    }}
                  >
                    <Form.Item
                      rootClassName="mb-2"
                      label="Document Name"
                      name="document_name"
                      rules={[
                        {
                          required: true,
                          message: "Please enter document name",
                        },
                      ]}
                    >
                      <Input placeholder="Enter document name" />
                    </Form.Item>

                    <Form.Item
                      rootClassName="mb-2"
                      label="Attachment"
                      name="document_url"
                    >
                      <FileUpload
                        placeholder="Choose file"
                        description="PDF, JPG, PNG (Max 5MB)"
                        name="document_url"
                        // disabled
                        form={fileForm}
                      />
                    </Form.Item>
                    <Flex gap={16} justify="end">
                      <Button
                        onClick={() => {
                          open.type === "ADD-FILE" &&
                            remove(open.data?.index as number);
                          fileForm.resetFields();
                          handleClose();
                        }}
                        size="small"
                        className="button-white-bordered"
                        htmlType="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        size="small"
                        htmlType="button"
                        className="button-primary min-w-20"
                        onClick={() => {
                          fileForm.submit();
                        }}
                      >
                        Save
                      </Button>
                    </Flex>
                  </Form>
                </CustomDrawer>
              </div>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

export default Documents;
